/** Copyright 2024 Midas Healthcare Solutions - All Rights Reserved **/
import { SortCriteriaItem } from "./base.types";
import { CollectionBin } from "./collection-bin.model";
import { IWorkflow } from "./workflow.model";

export interface BinSwap extends IWorkflow {
  cartId: number;
  cartName: string;
  locationId: number;
  locationName: string;
  binSwapName: string;
  binSwapTime: string;
  removedCollectionBin: CollectionBin;
  installedCollectionBin: CollectionBin;
  checkOnly: boolean;
}

export enum BinSwapSortCriteria {
  Date,
  Location,
  Cart,
  User
}

export type BinSwapSortCriteriaItem = SortCriteriaItem<typeof BinSwapSortCriteria>;

export interface QueryBinSwapsRequest {
  numberOfRecords: number;
  startingIndex: number;
  locations?: number[];
  carts?: number[];
  startDate?: string | null;
  endDate?: string | null;
  containerEvent: ContainerEvent[];
  sortByDateOldestFirst?: boolean;
}

export enum ContainerEvent {
  Insertion,
  Swap,
  Check
}
